import './App.css'
import Path from './router'

function App() {
    return <Path />
}

export default App
